/**
 * Internal dependencies
 */
import padding from './padding';
import margin from './margin';

export const styleDefinitions = [ margin, padding ];
